module.exports = __webpack_public_path__ + "static/media/show.0b98d760.svg";